var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-signup',{style:(_vm.mobile ? 'padding-top: 30px;' : 'margin-top: 30px;')})
}
var staticRenderFns = []

export { render, staticRenderFns }